import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { ThemeService } from './services/theme.service';
import { activeEnvironment } from './shared/helpers/environment.helper';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, ButtonModule, ToastModule, ConfirmDialogModule],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App {
    protected readonly title = signal('heartbeat-client');
    private translate = inject(TranslateService);

    constructor(
        private themeService: ThemeService
    ) {
        if (activeEnvironment !== 'prod') {
            this.themeService.dailyThemeToggle();
        }
    }
}
